<script>
  import EntityInput from "./EntityInput.svelte";
  import EntityGrid from "./EntityGrid.svelte";
  import Clock from "./Clock.svelte";
  import Export from "./Export.svelte";
  import { entities } from "./store.js";
</script>

<style>
  main {
    display: flex;
    font-family: sans-serif;
    flex-direction: column;
    align-items: center;
    margin: 0px 0.5cm 0px 0px;
  }
</style>

<main>
  <EntityInput bind:entities={$entities}/>
  <Clock />
  <EntityGrid entities={$entities} />
  <p>Short press to increment lap, long press to decrement lap.</p>
  <Export />
</main>
